import { Component, OnInit } from '@angular/core';
import { TdDialogService } from '@covalent/core';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-covalent',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;

  constructor(private _dialogService: TdDialogService,
    public _authService: AuthenticationService,
    private router: Router) { }

  ngOnInit() {

  }

  login() {
    this._authService.login(this.username, this.password).subscribe(
      response => {
        this._authService.setLoggedIn(true, response);
        this.router.navigate(['/']);
      },
      error => {
        this._authService.logout();
        this.openAlert();
      },
      () => {}
    );
  }

  openAlert(): void {
    this._dialogService.openAlert({
      message: 'Unauthorized. Please check credentials.',
      disableClose: true,
      title: 'Login Failed',
      closeButton: 'Close',
    });
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/login/login.component.ts